import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import useMaintenanceStatus from "./useMaintenanceStatus";
import { useAuth } from "../../../context/AuthContext";

const StatusPage = lazy(() => import("../../status/status"));

// Quando la manutenzione è attiva, chiunque visiti il sito vede SOLO la
// status page (con countdown o messaggio) invece del sito normale — TRANNE
// gli admin, che restano immuni e continuano a vedere il sito normalmente
// (così possono controllare/testare le cose prima di disattivare la
// manutenzione, invece di restare bloccati fuori pure loro).
// Il pannellino nascosto nel footer resta comunque raggiungibile perché
// la status page include il Footer.
export default function MaintenanceGate({ children }) {
  const { status } = useMaintenanceStatus();
  const { user, loading: authLoading } = useAuth();
  const { pathname } = useLocation();

  // /auth/login stays reachable even during maintenance — otherwise an
  // admin who got logged out (expired session, new device, cleared
  // storage...) would have no way back in while the site is down.
  if (pathname.startsWith("/auth/login")) {
    return children;
  }

  // Finché non sappiamo ancora lo stato della manutenzione o chi è
  // l'utente (primo caricamento), non blocchiamo il sito — evita anche che
  // un admin veda un lampo di status page prima che il suo login venga
  // riconosciuto.
  if (!status || authLoading) {
    return children;
  }

  if (!status.active || user?.role === "admin") {
    return children;
  }

  return (
    <Suspense fallback={null}>
      <StatusPage />
    </Suspense>
  );
}
